import React from "react";
import { Show, TabbedShowLayout, Tab, ShowProps } from "react-admin";
import { Grid } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import Summary from "./Summary";
import TitleBreadcrumb from "components/TitleBreadcrumb";
import CustomFormLabel from "components/CustomFormLabel";
import VehicleAssign from "./VehicleAssign";

const SubcontractorShow = (props: ShowProps) => {
  const { id } = props;

  const breadcrumb = [
    {
      title: "Subcontractors",
      link: `/subcontractors`,
    },
    {
      title: id,
      link: "",
    },
  ];

  return (
    <>
      <TitleBreadcrumb paths={breadcrumb} />
      <CustomFormLabel property={props} isNoActions />
      <Show {...props}>
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <TabbedShowLayout>
              <Tab label="Summary">
                <Summary {...props} />
              </Tab>
              <Tab label="Vehicle Assign">
                <VehicleAssign {...props} />
              </Tab>
              <Tab label="Internal Note">
                {/* <DistanceArea {...props} /> */}
              </Tab>
            </TabbedShowLayout>
          </Grid>
        </SanitizedGrid>
      </Show>
    </>
  );
};

export default SubcontractorShow;
